import { matchPath, useLocation } from "react-router-dom";

import * as routes from "../routes";

export const useMatchRoute = () => {
  const { pathname } = useLocation();

  return Object.values(routes)
    .flat()
    .find((route) => matchPath({ path: route.path }, pathname));
};
